var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"version-info"},[_vm._v(" "+_vm._s(_vm.env)+" v"+_vm._s(_vm.appVersion)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }